/**
 * Organization phone and email for browser scripts.
 *
 * views/layout.ejs writes them once on <body> (data-org-phone / data-org-email)
 * from config/business/config.json, so bundled JS never carries its own copy
 * of the number or address (redesign spec §14.3).
 */

export function getOrgContact() {
    const data = (typeof document !== 'undefined' && document.body && document.body.dataset) || {};
    return { phone: data.orgPhone || '', email: data.orgEmail || '' };
}

/** "info@… or (555) 555-0100", for "reach us directly at …" error copy. */
export function orgContactPhrase() {
    const { phone, email } = getOrgContact();
    return [email, phone].filter(Boolean).join(' or ') || 'our office';
}
